import React from 'react';
import { Card, Typography, Box } from '@mui/material';
import { helpSectionStyles } from './HelpSection.styles';

const HelpSection = () => {
  const styles = helpSectionStyles;

  return (
    <Card sx={styles.card}>
      <Typography sx={styles.title}>Need Help to get started?</Typography>
      
      <Box sx={styles.content}>
        <Typography sx={styles.introText}>
          Ready to elevate your property to new heights? Here's how to list your property with Royal Vista and unlock unparalleled luxury management:
        </Typography>

        <Box sx={styles.listContainer}>
          <Typography component="div" sx={styles.listItem}>
            <Typography component="span" sx={styles.listNumber}>1- Property Type:</Typography> Begin by selecting the type of property you wish to list.
          </Typography>

          <Typography component="div" sx={styles.listItem}>
            <Typography component="span" sx={styles.listNumber}>2- Property Details:</Typography> Provide an enticing title and comprehensive description.
          </Typography>

          <Typography component="div" sx={styles.listItem}>
            <Typography component="span" sx={styles.listNumber}>3- Photos & Videos:</Typography> Showcase your property's best features with high-quality visuals.
          </Typography>

          <Typography component="div" sx={styles.listItem}>
            <Typography component="span" sx={styles.listNumber}>4- Address:</Typography> Enter the full address of your property.
          </Typography>

          <Typography component="div" sx={styles.listItem}>
            <Typography component="span" sx={styles.listNumber}>5- Property Features:</Typography> Specify key details such as payment types, pricing, floor level, parking spaces, number of bedrooms/beds/bathrooms/balconies, furnishing status, and sizes.
          </Typography>

          <Typography component="div" sx={styles.listItem}>
            <Typography component="span" sx={styles.listNumber}>6- Ownership Details:</Typography> Indicate ownership type, condition, and year built.
          </Typography>
        </Box>

        <Typography sx={styles.closingText}>
          Once submitted, our expert team will review your listing. Upon approval, Royal Vista will handle everything from bookings to management, ensuring your property offers guests an unforgettable experience.
        </Typography>
      </Box>
    </Card>
  );
};

export default HelpSection;

